import React from "react";
import Courses from "../components/courses";
import Footer from "../components/Navbars/footer";

function ManageCourses() {
  return (
    <div className="w-full max-w-[95%] 2xl:max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8">
      <main className="">
        <Courses />
      </main>
    </div>
  );
}

export default ManageCourses;
